import { FC, useEffect } from 'react';
import { groupTrendStore } from '@modules/groupTrend/adapter/outbound/stores/groupTrend.store';
import TrendAnimation from '@components/collection/trendAnimation/TrendAnimation';
import GroupTrendSkeleton from '@components/skeleton/groupTrend/GroupTrend';
import useLockedBody from '@shared/utils/hooks/useLockedBody.utils';
const TrendAnimationProvider: FC = () => {
  const [_locked, setLocked] = useLockedBody(false, 'root');
  const {
    groupTrend,
    setGroupTrend
  } = groupTrendStore(state => state);
  useEffect(() => {
    if (!groupTrend?.topContent) {
      setGroupTrend();
    }
  }, []);
  useEffect(() => {
    if (!groupTrend?.topContent) {
      setLocked(true);
    } else {
      setLocked(false);
    }
  }, [groupTrend]);
  return groupTrend?.topContent ? <TrendAnimation data={groupTrend} /> : <GroupTrendSkeleton />;
};
export default TrendAnimationProvider;